// extracted by mini-css-extract-plugin
export default {"container":"_V-z","title":"aW-z","link":"bW-z"};